import React, { useEffect, useRef, useState } from 'react';
import { Badge, ButtonBase, IconButton } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import './motion.css';

export const BUBBLE_MS = 4000;
export const BELL_SLOT_ID = 'svx-bell-slot';

export default function NotificationBell({ count, latestTitle, onOpen }) {
  const [ringing, setRinging] = useState(false);
  const [bubble, setBubble] = useState(0);
  const prev = useRef(null);
  const root = useRef(null);

  useEffect(() => {
    const before = prev.current;
    prev.current = count;
    if (count === null || before === null || count <= before) return;
    setRinging(true);
    if (latestTitle) setBubble((n) => n + 1);
  }, [count, latestTitle]);

  useEffect(() => {
    if (!bubble) return undefined;
    const t = setTimeout(() => setBubble(0), BUBBLE_MS);
    const onKey = (e) => { if (e.key === 'Escape') setBubble(0); };
    const onDown = (e) => { if (!root.current?.contains(e.target)) setBubble(0); };
    document.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onDown);
    return () => {
      clearTimeout(t);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onDown);
    };
  }, [bubble]);

  const open = () => { setBubble(0); onOpen?.(); };
  const total = count || 0;

  return (
    <span ref={root} className={`svx-bell ${ringing ? 'is-ringing' : ''}`} onAnimationEnd={(e) => { if (e.animationName === 'svx-swing') setRinging(false); }}>
      <IconButton onClick={open} aria-label={`${total} notification${total === 1 ? '' : 's'}`}>
        <Badge badgeContent={total} color="error" max={99}>
          <NotificationsNoneIcon className="svx-bell__icon" />
        </Badge>
      </IconButton>
      {bubble > 0 && (
        <ButtonBase className="svx-bell__bubble" onClick={open}>
          {latestTitle}
        </ButtonBase>
      )}
      <span className="svx-sr" role="status" aria-live="polite">
        {bubble > 0 ? `New notification: ${latestTitle}` : ''}
      </span>
    </span>
  );
}
